import { createContext, useContext, ReactNode } from "react";

type DashboardPreview = {
  preview: boolean;
  email?: string;
};

const DashboardPreviewContext = createContext<DashboardPreview>({ preview: false });

export const DashboardPreviewProvider = ({
  email,
  children,
}: {
  email: string;
  children: ReactNode;
}) => (
  <DashboardPreviewContext.Provider value={{ preview: true, email }}>
    {children}
  </DashboardPreviewContext.Provider>
);

export const useDashboardPreview = () => useContext(DashboardPreviewContext);
